module.exports = __webpack_public_path__ + "img/mischakim_yes.52488514.png";